<template>
  <div class="paper-pre-rejoin-report">
    <AppScrollbar style="height: 100%">
      <div class="main-cont">
        <div class="upload-cont">
          <DataUnpackModule :unpack-url="uploadUrl"
                            :pre-handle-params="uploadParams"
                            inline></DataUnpackModule>
        </div>
      </div>
    </AppScrollbar>
  </div>
</template>

<script>
import DataUnpackModule from '../../../../../../elements/DataUnpackModule'
import AppScrollbar from '../../../../../../elements/AppScrollbar'
export default {
  name: 'PaperPreRejoinReport',
  props: {
    paperBatchId: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  components: {
    AppScrollbar,
    DataUnpackModule
  },
  data () {
    return {
      uploadUrl: '/workspace/manager/paper/preRejoin/upload'
    }
  },
  methods: {
    uploadParams () {
      return {
        paperBatchId: this.paperBatchId
      }
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (!val) {
          this.$emit('reloadGridData')
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.paper-pre-rejoin-report{
  height: 100%;
  .main-cont {
    width: 100%;
    max-width: 100%;
    padding: 10px;
  }
}
</style>
